"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SwitchToSocialStep = void 0;
const react_1 = __importDefault(require("react"));
const Button_1 = require("@food/ui/build/dist/src/Button");
const css_manager_1 = require("@food/css-manager");
const SocialLogin_1 = require("./SocialLogin");
const SocialButtons_1 = require("./SocialButtons");
const types_1 = require("../types");
const Sentry = __importStar(require("@sentry/browser"));
const flexRow = (0, css_manager_1.registerClass)(() => `
	flex-direction: row;
`);
const flexCol = (0, css_manager_1.registerClass)(() => `
	flex-direction: column;
`);
const stepSection = (0, css_manager_1.registerClass)((theme, sc) => `
	padding: ${(theme.ratios.l / 4) * theme.font.baseSize}px ${theme.ratios.l *
    theme.font.baseSize}px;

	> div {
		display: flex;
		justify-content: space-between;

		> div {
			flex-grow: 1;
		}
	}
	
	.${sc('buttons')} {
		margin: ${theme.ratios.xl * theme.font.baseSize}px;
	}
	
	.${sc('renew-intro')} {
		margin: 1em;
		text-align: center;
	}
	
	.${sc('change-login-type')} {
		text-align: center;
	}
	
	.${sc('login-buttons')} {
		text-align: center;

		>button {
			margin: ${(theme.ratios.xl / 2) * theme.font.baseSize}px;
		}
	}
	
	&.${sc('layout', 'STANDARD')} > div > div {
		flex-basis: ${theme.font.baseSize}px;
	}
	
	.${sc('explanation-title')} {
		font-size: ${theme.ratios.xl * theme.font.baseSize}px;
		line-height: ${2 * theme.font.baseSize}px;
	}
	
	.${sc('explanation-text')} {
		margin-top: ${theme.ratios.xl * theme.font.baseSize}px;
	}
	
	.${sc('explanation')} {
		display: flex;
		justify-content: center;
		flex-direction: column;
		height: 100%;
		padding-bottom: ${theme.ratios.xl * 2 * theme.font.baseSize}px;
	}
`);
const marginBottom = (0, css_manager_1.registerClass)((theme) => `margin-bottom: ${theme.ratios.l * theme.font.baseSize}px;`);
const sc = (0, css_manager_1.currySC)(stepSection);
const SwitchToSocialStep = ({ t, socialTypes, layout, performLogin, errors, maybeLaterHandler, }) => (react_1.default.createElement(react_1.default.Fragment, null,
    react_1.default.createElement("h2", null, t `Switch to Social Account`),
    react_1.default.createElement("section", { className: (0, css_manager_1.classNames)(stepSection, sc('layout', layout)) },
        react_1.default.createElement("div", { className: layout === SocialLogin_1.SOCIAL_LOGIN_LAYOUTS.STANDARD ? flexRow : flexCol },
            react_1.default.createElement("div", null,
                react_1.default.createElement("div", { className: sc('explanation') },
                    react_1.default.createElement("div", { className: sc('explanation-title') }, t `switch to social explanation title`),
                    react_1.default.createElement("div", { className: sc('explanation-text'), dangerouslySetInnerHTML: {
                            __html: t `switch to social explanation html`,
                        } }))),
            react_1.default.createElement("div", { className: sc('buttons') },
                react_1.default.createElement("div", { className: marginBottom },
                    react_1.default.createElement("div", null, t `Associate a social account to your user`)),
                errors,
                react_1.default.createElement(SocialButtons_1.SocialButtons, { socials: socialTypes, onClick: (args) => {
                        // Checking that onClick was given good args
                        if (args &&
                            args.fixedSocial &&
                            (0, types_1.isSocial)(args.fixedSocial)) {
                            performLogin(args.fixedSocial);
                        }
                        else {
                            Sentry.withScope((scope) => {
                                scope.setExtra('onClick args', args);
                                Sentry.captureException(new Error('SocialButtons.onClick unsupported args'));
                            });
                        }
                    }, t: t }),
                react_1.default.createElement("div", { className: sc('login-buttons') },
                    react_1.default.createElement(Button_1.Button, { onClick: maybeLaterHandler, layout: Button_1.layouts.LINK, label: t `Maybe later` })))))));
exports.SwitchToSocialStep = SwitchToSocialStep;
//# sourceMappingURL=SwitchToSocial.js.map